import type { GroupedBankingSourcesSchema } from "bankconnect";

export const shouldShowNewAccountsPage = (
  newAccountsPageEnabled: boolean | undefined,
  { accountGroups, ungroupedConnections, ungroupedStatements }: GroupedBankingSourcesSchema
): boolean => {
  if (!newAccountsPageEnabled) {
    return false;
  }

  // A null extractionState means extraction was never attempted for that statement so it cannot count as evidence of the new flow.
  const hasNewFlowEvidence =
    accountGroups.length > 0 || ungroupedStatements.some((statement) => statement.extractionState !== null);
  const hasAnyBankingData =
    accountGroups.length > 0 || ungroupedConnections.length > 0 || ungroupedStatements.length > 0;

  return hasNewFlowEvidence || !hasAnyBankingData;
};
